/**
 * sheet 对外暴露的接口
 */
export var SheetInterface;
(function (SheetInterface) {
    // api 执行成功和失败结果码
    var AI_OPERATE_CODE;
    (function (AI_OPERATE_CODE) {
        AI_OPERATE_CODE[AI_OPERATE_CODE["ERROR_CODE"] = -1] = "ERROR_CODE";
        AI_OPERATE_CODE[AI_OPERATE_CODE["SUCCESS_CODE"] = 0] = "SUCCESS_CODE";
    })(AI_OPERATE_CODE = SheetInterface.AI_OPERATE_CODE || (SheetInterface.AI_OPERATE_CODE = {}));
    // 操作的方向，up: 上；down：下
    var IRowsDirection;
    (function (IRowsDirection) {
        IRowsDirection["UP"] = "up";
        IRowsDirection["DOWN"] = "down";
    })(IRowsDirection = SheetInterface.IRowsDirection || (SheetInterface.IRowsDirection = {}));
    // 操作的方向，before: 前；after：后
    var IColsDirection;
    (function (IColsDirection) {
        IColsDirection["BEFORE"] = "before";
        IColsDirection["AFTER"] = "after";
    })(IColsDirection = SheetInterface.IColsDirection || (SheetInterface.IColsDirection = {}));
    // 具体操作类型
    var IAction;
    (function (IAction) {
        IAction["INSERT"] = "insert";
        IAction["DELETE"] = "delete";
    })(IAction = SheetInterface.IAction || (SheetInterface.IAction = {}));
    /**
     * 调整行类型，high: 调高；low：调低
     */
    var IResizeRowType;
    (function (IResizeRowType) {
        IResizeRowType["HIGH"] = "high";
        IResizeRowType["LOW"] = "low";
    })(IResizeRowType = SheetInterface.IResizeRowType || (SheetInterface.IResizeRowType = {}));
    /**
     * 调整列类型，wide: 调宽；narrow：调窄
     */
    var IResizeColType;
    (function (IResizeColType) {
        IResizeColType["WIDE"] = "wide";
        IResizeColType["NARROW"] = "narrow";
    })(IResizeColType = SheetInterface.IResizeColType || (SheetInterface.IResizeColType = {}));
    /**
     * 操作单元格内容
     */
    var IOperateCellType;
    (function (IOperateCellType) {
        IOperateCellType["WRITE"] = "write";
        IOperateCellType["CLEAR"] = "clear";
    })(IOperateCellType = SheetInterface.IOperateCellType || (SheetInterface.IOperateCellType = {}));
    /**
     * 富文本样式
     * 对应的操作：bold代表加粗字体；italic代表字体变为斜体；strikethrough代表字体加删除线；underline代表字体加下划线
     */
    var TextPropKey;
    (function (TextPropKey) {
        TextPropKey["BOLD"] = "bold";
        TextPropKey["ITALIC"] = "italic";
        TextPropKey["UNDERLINE"] = "underline";
        TextPropKey["STRIKETHROUGH"] = "strikethrough";
    })(TextPropKey = SheetInterface.TextPropKey || (SheetInterface.TextPropKey = {}));
    /**
     * 函数计算错误的类型
     */
    var STErrorCode;
    (function (STErrorCode) {
        STErrorCode[STErrorCode["PBDEFAULT"] = 0] = "PBDEFAULT";
        STErrorCode[STErrorCode["Error"] = 1] = "Error";
        STErrorCode[STErrorCode["Null"] = 2] = "Null";
        STErrorCode[STErrorCode["Div0"] = 3] = "Div0";
        STErrorCode[STErrorCode["Value"] = 4] = "Value";
        STErrorCode[STErrorCode["Ref"] = 5] = "Ref";
        STErrorCode[STErrorCode["Name"] = 6] = "Name";
        STErrorCode[STErrorCode["Num"] = 7] = "Num";
        STErrorCode[STErrorCode["Na"] = 8] = "Na";
        STErrorCode[STErrorCode["Spill"] = 9] = "Spill";
        STErrorCode[STErrorCode["Calc"] = 10] = "Calc";
        STErrorCode[STErrorCode["GettingData"] = 11] = "GettingData";
        STErrorCode[STErrorCode["Loading"] = 12] = "Loading";
        STErrorCode[STErrorCode["ParamsError"] = 13] = "ParamsError";
        STErrorCode[STErrorCode["ParamsMissing"] = 14] = "ParamsMissing";
        STErrorCode[STErrorCode["ParamsExceeded"] = 15] = "ParamsExceeded";
        STErrorCode[STErrorCode["NotViewable"] = 16] = "NotViewable";
        STErrorCode[STErrorCode["IncompatibleData"] = 17] = "IncompatibleData";
    })(STErrorCode = SheetInterface.STErrorCode || (SheetInterface.STErrorCode = {}));
    /**
     * 合并单元格的操作
     */
    var IMergeActionType;
    (function (IMergeActionType) {
        IMergeActionType["MERGE"] = "merge";
        IMergeActionType["UN_MERGE"] = "unmerge";
    })(IMergeActionType = SheetInterface.IMergeActionType || (SheetInterface.IMergeActionType = {}));
    var TemplateSheetType;
    (function (TemplateSheetType) {
        TemplateSheetType["SMART_SHEET"] = "smartsheet";
        // 理论上没有下面两种, 保险起见兜个底
        TemplateSheetType["SHEET"] = "sheet";
        TemplateSheetType["SMART_CANVAS"] = "smartcanvas";
    })(TemplateSheetType = SheetInterface.TemplateSheetType || (SheetInterface.TemplateSheetType = {}));
})(SheetInterface || (SheetInterface = {}));
//# sourceMappingURL=sheet.js.map